module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_02_6DB79_1SB_HIT.e51cd33f.jpg";